const MegaCourseMenuTransform = (props) => {
	return { ...props, isMegaMenu: true };
};

export default MegaCourseMenuTransform;
